// TODO - Documentar
import { GenericElement } from '../../templates/FormElement';

// Global constants
import * as con from "../../GlobalConstants"


import "../ComponentsGlobalStyle.css"
import { StateMarketValueHook } from '../hooks/MarketValuesHook';
import { StateModelParameterHook } from '../hooks/ModelParameterHooks';

function ScenariosParameters() {


    // Model Parameters
    // -----------------
    const [termPeriodicity, setTermPeriodicity] = StateModelParameterHook(con.TERM_PERIODICITY)
    const [escPercentualChange, setEscPercentualChange] = StateModelParameterHook(con.ESC_PERCENTUAL_CHANGE)    
    const [market_volatility, setVolatility] = StateMarketValueHook(con.MARKET_VOLATILITY);
    const [escConfidenceLevel, setEscConfidenceLevel] = StateModelParameterHook(con.ESC_CONFIDENCE_LEVEL);
    

    
    return (

        <div className="mediumParameterBox" >

                    < GenericElement type={con.NUMERIC}
                            name={"Plazo en Meses"}
                            id={"term_periodicity"} 
                            value={termPeriodicity} 
                            setValue={(val) => setTermPeriodicity(val)} /> 
                                 

                    < GenericElement type={con.PERCENTAGE} 
                                    name={"Cambio Porcentual (Esc.)"}
                                    id={"esc_percentual_change"} 
                                    value={escPercentualChange} 
                                    setValue={(val) => setEscPercentualChange(val)} 
                                    min={-100}
                                    max={100} />                                
                    
                    < GenericElement type={con.PERCENTAGE}
                                    name={"Confianza (Esc.)"}
                                    id={"esc_confidence_level"} 
                                    value={escConfidenceLevel} 
                                    setValue={(val) => setEscConfidenceLevel(val)}
                                    max={99} />

                < GenericElement type={con.PERCENTAGE}
                                name={"Volatilidad del Mercado"}
                                id={"market_volatilty"} 
                                value={market_volatility} 
                                setValue={(val) => setVolatility(val)} /> 
        </div>
           
    )
}

export default ScenariosParameters
